import useTemplateStatus from "./useTemplateStatus";

export default function useIsFinalizedTemplate() {
  const status = useTemplateStatus();
  return status === "VALIDATED";
}
